<template lang="pug">
  div(:class="$style.overlayImage")
    template(v-if="block.innerBlocks[0]")
      Block(:block="block.innerBlocks[0]" class="flex justify-center")
    div(:class="$style.overlayBlock")
      template(v-if="block.innerBlocks[1]")
        Block(:block="block.innerBlocks[1]")
    div(:class="$style.spacerBlock")
</template>

<script lang="ts">
export default {
  name: "ImageOverlay",

  props: {
    block: {
      type: Object,
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="css" module>
.overlayImage {
  @apply relative mb-ds-lg;

  figure {
    @apply rounded-2xl;
  }

  .overlayBlock {
    @apply absolute left-[50%] flex flex-col items-start gap-ds-sm self-stretch pl-0;
    @apply transform -translate-x-1/2 -translate-y-1/2;
  }
  .spacerBlock {
    @apply h-ds-xl;
  }
}

@screen md {
  .overlayImage {
    @apply mb-ds-xl;
  }
}

@screen xl {
  .overlayImage {
    @apply mb-ds-xxl;

    figure {
      @apply rounded-4xl;
    }

    .overlayBlock {
      @apply left-[40%];
    }
    .spacerBlock {
      @apply h-0;
    }
  }
}

@screen rebrandLg {
  .overlayImage {
    .overlayBlock {
      @apply left-[30%];
    }
  }
}
</style>
